import axios from '../common/axios';

async function getMillInit(placeCode: string, tabName: string): Promise<any[]> {
  return axios.get(`data/millInit/${placeCode}?tabName=${tabName}`).then((res) => res.data);
}

async function getIsConfirmation(placeCode: string, metricTypeId: number, yearMonth: number): Promise<boolean> {
  return axios
    .get(`data/isConfirmation/${placeCode}?metricTypeId=${metricTypeId}&yearMonth=${yearMonth}`)
    .then((res) => res.data);
}

async function getMeasurementsLookup(placeCode: string, metricType: string, yearMonth: number): Promise<any[]> {
  return axios
    .get(`data/measurementsLookup/${placeCode}?metricType=${metricType}&yearMonth=${yearMonth}`)
    .then((res) => res.data);
}

async function getTargets(placeCode: string, sourceName: string, metricType: string, year: number): Promise<any[]> {
  return axios.get(`data/targets/${placeCode}?sourceName=${sourceName}&metricType=${metricType}&year=${year}`).then((res) => res.data);
}

async function getTargetsTotal(placeCode: string, sourceName: string, year: number): Promise<any[]> {
  return axios.get(`data/targetstotal/${placeCode}?year=${year}&sourceName=${sourceName}`).then((res) => res.data);
}

async function submitChanges(data: any): Promise<any[]> {
  return axios.post(`data/submit`, data).then((res) => res.data);
}

async function submitTargets(data: any): Promise<any[]> {
  return axios.post(`data/submitTarget`, data).then((res) => res.data);
}

async function getSubmittedTargets(placeCode: string, sourceName: string, year: number): Promise<any[]> {
  return axios.get(`data/submittedTargets/${placeCode}?sourceName=${sourceName}&year=${year}`).then((res) => res.data);
}

async function confirmAllEntries(data: any): Promise<any[]> {
  return axios.post(`data/confirmEntries`, data).then((res) => res.data);
}

async function approveTargetSubmission(data: any): Promise<any[]> {
  return axios.post(`data/approvTatgetSubmission/${data.submissionId}`, null).then((res) => res.data);
}

async function rejectTargetSubmission(data: any): Promise<any[]> {
  return axios.post(`data/rejectTatgetSubmission/${data.submissionId}`, null).then((res) => res.data);
}

async function getSourcesValueList(): Promise<any[]> {
  return axios.get(`data/sources`).then((res) => res.data);
}

async function getSourceDetailValues(placeCode: string, source: number, yearMonth: number): Promise<any[]> {
  return axios.get(`data/energySources/${placeCode}?source=${source}&yearMonth=${yearMonth}`).then((res) => res.data);
}

async function submitSources(data: any): Promise<any[]> {
  return axios.post(`data/submitEnergySources`, data).then((res) => res.data);
}

export {
  getMillInit,
  getMeasurementsLookup,
  getTargets,
  getTargetsTotal,
  submitChanges,
  submitTargets,
  getSubmittedTargets,
  confirmAllEntries,
  approveTargetSubmission,
  rejectTargetSubmission,
  getSourcesValueList,
  getSourceDetailValues,
  submitSources,
  getIsConfirmation,
};
